<template>
  <section class="dash">
    <tool-bar pageTitle="BOOK.SIGHT"> </tool-bar>
    <div :class="handleBlur"></div>

    <!-- TODO-->
  </section>
</template>
<script>
import { mapStores } from "pinia";
import ToolBar from "../components/layout/ToolBar.vue";
import { useCoreStore } from "@/store/coreStore";
export default {
  components: {
    ToolBar,
  },
  name: "Book",
  computed: {
    ...mapStores(useCoreStore),
    handleBlur() {
      return this.coreStore.evaluateBlur(this.$options.name) ? "blur-background" : "";
    },
  },
};
</script>
<style>

</style>
